import React, { useContext } from "react";
import "./PageTen.scss";
import { BuildingsContext } from "../../../bContext";

function PageTen() {
  const { switchToEnglish } = useContext(BuildingsContext);
  return (
    <>
      <div className="pageTen">
        {/* <div className="menu-pg4"></div> */}

        <div>
          <div className="speech-bubble5">
            {switchToEnglish === false ? (
              <p className="first">
                W tym miejscu wyświetla się nazwa wybranego obiektu.
              </p>
            ) : (
              <p className="first">
                The name of the selected object is displayed here
              </p>
            )}
            <div className="inner-triangle-right5"></div>
          </div>
          {/* <div className="speech-bubble6">
            <p className="first">
              ...natomiast jego nazwa wyświetli się w tym okienku.
            </p>
            <div className="inner-triangle-right6"></div>
          </div> */}
          {/* <div className="menu-pg5"></div>  */}

          <div className="modal-header-ins"></div>
          <div className="modalbtn"></div>
          <div className="defaultbtn"></div>
        </div>
      </div>
    </>
  );
}

export default PageTen;
